import { Form, Input } from 'antd';

const { Item } = Form;
const { TextArea } = Input;

export const OperationCommentField = () => (
  <Item name="Comment" label="Комментарий" wrapperCol={{ span: 7 }}>
    <TextArea
      placeholder="Введите комментарий"
      autoSize={{ minRows: 4, maxRows: 10 }}
      className="full-width"
      maxLength={4000}
    />
  </Item>
);
